import React from 'react';
import CompareSelector from './components/CompareSelector';
import PowerSolution from './componentsEU/PowerSolution';
import A from './componentsNA/A';
import D from './componentsNA/D';
import E from './componentsNA/E';
import F from './componentsNA/F';
import G from './componentsNA/G';
import H from './componentsNA/H';
import I from './componentsNA/I';
import J from './componentsNA/J';
import K from './componentsNA/K';
import L from './componentsNA/L';
import N from './componentsNA/N';
import css from './NA.module.scss';

const EU_Product_V2: React.FC = ({}) => {
    return (
        <div className={`page-product ${css.pageProduct}`}>
            <A />
            <PowerSolution />
            <D />
            <E />
            <F />
            <G />
            <H />
            <I />
            <J />
            <K />
            <L />
            <CompareSelector />
            <N />
        </div>
    );
};
export default EU_Product_V2;
